// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IconType } from "./icon-type";
import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A monitoring icon definition.
 */
export class Icon implements flatbuffers.IUnpackableObject<IconT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Icon {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIcon(bb: flatbuffers.ByteBuffer, obj?: Icon): Icon {
    return (obj || new Icon()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIcon(bb: flatbuffers.ByteBuffer, obj?: Icon): Icon {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Icon()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  message(): string | null;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  message(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  shortMessage(): string | null;
  shortMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  shortMessage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  icon(): string | null;
  icon(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  icon(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  iconType(): IconType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : IconType.STATUS;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startIcon(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static addShortMessage(builder: flatbuffers.Builder, shortMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, shortMessageOffset, 0);
  }

  static addIcon(builder: flatbuffers.Builder, iconOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, iconOffset, 0);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(4, liftType, LiftType.ELEVATOR);
  }

  static addIconType(builder: flatbuffers.Builder, iconType: IconType) {
    builder.addFieldInt8(5, iconType, IconType.STATUS);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, deletedAtOffset, 0);
  }

  static endIcon(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIcon(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    messageOffset: flatbuffers.Offset,
    shortMessageOffset: flatbuffers.Offset,
    iconOffset: flatbuffers.Offset,
    liftType: LiftType,
    iconType: IconType,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Icon.startIcon(builder);
    Icon.addId(builder, idOffset);
    Icon.addMessage(builder, messageOffset);
    Icon.addShortMessage(builder, shortMessageOffset);
    Icon.addIcon(builder, iconOffset);
    Icon.addLiftType(builder, liftType);
    Icon.addIconType(builder, iconType);
    Icon.addCreatedAt(builder, createdAtOffset);
    Icon.addUpdatedAt(builder, updatedAtOffset);
    Icon.addDeletedAt(builder, deletedAtOffset);
    return Icon.endIcon(builder);
  }

  unpack(): IconT {
    return new IconT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.message(),
      this.shortMessage(),
      this.icon(),
      this.liftType(),
      this.iconType(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: IconT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.message = this.message();
    _o.shortMessage = this.shortMessage();
    _o.icon = this.icon();
    _o.liftType = this.liftType();
    _o.iconType = this.iconType();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): IconT {
    const t = new IconT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("short_message")) {
      t.shortMessage = this.shortMessage();
    }
    if (fieldSet.has("icon")) {
      t.icon = this.icon();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("icon_type")) {
      t.iconType = this.iconType();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class IconT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public message: string | Uint8Array | null = null,
    public shortMessage: string | Uint8Array | null = null,
    public icon: string | Uint8Array | null = null,
    public liftType: LiftType = LiftType.ELEVATOR,
    public iconType: IconType = IconType.STATUS,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const message = this.message !== null ? builder.createString(this.message!) : 0;
    const shortMessage = this.shortMessage !== null ? builder.createString(this.shortMessage!) : 0;
    const icon = this.icon !== null ? builder.createString(this.icon!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return Icon.createIcon(
      builder,
      id,
      message,
      shortMessage,
      icon,
      this.liftType,
      this.iconType,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): IconT {
    const obj = new IconT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.message = this.message;
    obj.shortMessage = this.shortMessage;
    obj.icon = this.icon;
    obj.liftType = this.liftType;
    obj.iconType = this.iconType;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: IconT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.message !== other.message) return false;
    if (this.shortMessage !== other.shortMessage) return false;
    if (this.icon !== other.icon) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.iconType !== other.iconType) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyIcon(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
